import { Loader2 } from "lucide-react";

import { useKakaoAuth } from "@/features/auth/hooks/useKakaoAuth";

import { Button } from "@/components/ui/button";

interface KakaoLoginButtonProps {
  disabled?: boolean;
}

export function KakaoLoginButton({ disabled }: KakaoLoginButtonProps) {
  const { isLoading, handleLogin } = useKakaoAuth();

  return (
    <Button
      type="button"
      className="h-10 w-full bg-[#FEE500] font-medium text-neutral-900 hover:bg-[#FEE500]/90 focus-visible:ring-[#FEE500]/50"
      onClick={handleLogin}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 3C6.48 3 2 6.36 2 10.44c0 2.61 1.74 4.9 4.36 6.22-.14.53-.9 3.4-.93 3.61 0 0-.02.16.08.22.1.06.22.03.22.03.29-.04 3.37-2.2 3.9-2.57.77.11 1.57.17 2.37.17 5.52 0 10-3.36 10-7.68S17.52 3 12 3" />
        </svg>
      )}
      카카오로 시작하기
    </Button>
  );
}
